<template>
  <div id="trueLabelChartID" style="width: 900px; height: 450px; overflow-x: hidden; overflow-y: auto;">
    <div class="flex_row">
      <div id="groundtruth_true" style="width: 400px;height: 400px">
        <h3 style="margin-top: 0;padding-top: 0">
          <span>{{this.picText}}</span>
        </h3>
        <img :src="groundtruth_source" width="300px" id="true_pic" alt=""
                   @error="hidePic"/>
        <!--           onerror="document.getElementById('groundtruth_true').style.display = 'none'"/></div>-->
        <div>
          <span @click="resetPic('true_pic')">
            <i class="el-icon-refresh"></i>
          </span>
          <span @click="rotatePic('true_pic')">
            <i class="el-icon-refresh-right"></i>
          </span>
          <span @click="horizonPic('true_pic')">
            <i class="el-icon-right"></i>
          </span>
          <span @click="verticalPic('true_pic')">
            <i class="el-icon-top"></i>
          </span>
        </div>
      </div>
      <div id="class_true" style="width: 400px;height: 400px"/>
      <div id="anno_true" style="width: 400px;height: 400px"/>
      <div id="fine_anno_true" style="width: 400px;height: 400px"/>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts/core";

export default {
  name: "TrueLabelChart",
  data(){
    return{
      datasetName: [20210101, 20210701, 20210702, 20210703],
      picText: 'H&E image',
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
      datasetID: 0,
      groundtruth_source: '',
      COLOR_ALL: [
        '#37A2DA',
        '#e06343',
        '#37a354',
        '#b55dba',
        '#b5bd48',
        '#8378EA',
        '#96BFFF',
        '#E72178',
        '#354E6C','#EAAC31',
        '#EAD2AE',
        '#127678','#30B5A4','#B4D9D2',
        '#354581','#FFE074',
        '#E03C79','#88C1B8',
        '#FC6746','#F5B307','#008186'
      ],
      classification_info: {
        types: [],
        spotSize: 1,
        tip: [],
        source: []
      },
      annot_type_info: {
        types: [],
        spotSize: 1,
        tip: [],
        source: []
      },
      fine_annot_type_info: {
        types: [],
        spotSize: 1,
        tip: [],
        source: []
      },
    }
  },
  props:{
    asynDatasetID: Number,
    asynClassification: {
      types: Array,
      spotSize: Number,
      tip: Array,
      source: Array
    },
    asynAnnot: {
      types: Array,
      spotSize: Number,
      tip: Array,
      source: Array
    },
    asynFineAnno: {
      types: Array,
      spotSize: Number,
      tip: Array,
      source: Array
    },
    asynGround: String,
  },
  mounted() {
    if (this.groundtruth_source === ''){
      this.groundtruth_source = this.asynGround
      this.datasetID = this.asynDatasetID
      this.classification_info= this.asynClassification
      this.annot_type_info= this.asynAnnot
      this.fine_annot_type_info= this.asynFineAnno
      console.log(this.groundtruth_source)
      console.log(this.classification_info)
      console.log(this.annot_type_info)
      console.log(this.fine_annot_type_info)
      // console.log(this.datasetName)
      // console.log(this.datasetID)
      // console.log(this.datasetName.includes(parseInt(this.datasetID)))
      if (this.datasetName.includes(this.datasetID)){
        this.picText = 'Immunofluorescent imaging'
        // console.log(this.picText)
      }
      this.$nextTick(function () {
        this.hideEmptyEcharts()
        // this.hidePic()
        this.initClassificationEcharts()
        this.initAnnoEcharts()
        this.initFineAnnoEcharts()
      })
      // setTimeout(()=>{
      //   // console.log(this.groundtruth_source)
      //   // console.log(this.classification_info)
      //   // console.log(this.annot_type_info)
      //   // console.log(this.fine_annot_type_info)
      //   this.hideEmptyEcharts()
      //   // this.hidePic()
      //   this.initClassificationEcharts()
      //   this.initAnnoEcharts()
      //   this.initFineAnnoEcharts()
      // },500)
    }
  },
  methods: {
    hideEmptyEcharts () {
      if (this.classification_info.source.length === 0){
        document.getElementById('class_true').style.display = "none"
      }
      if (this.annot_type_info.source.length === 0){
        document.getElementById('anno_true').style.display = "none"
      }
      if (this.fine_annot_type_info.source.length === 0){
        document.getElementById('fine_anno_true').style.display = "none"
      }
    },
    resetPic(elename) {
      this.rotateX = 0
      this.rotateY = 0
      this.rotateZ = 0
      var box = document.getElementById(elename);
      box.style.transform = 'rotateX(' + 0 + 'deg)';
      box.style.transform = 'rotateY(' + 0 + 'deg)';
      box.style.transform = 'rotateZ(' + 0 + 'deg)';
    },
    rotatePic(elename) {
      this.rotateZ = this.rotateZ + 1
      var box = document.getElementById(elename);
      box.style.transform = 'rotateZ(' + 90 * this.rotateZ + 'deg)';
    },
    horizonPic(elename) {
      this.rotateY = this.rotateY + 1
      var box = document.getElementById(elename);
      box.style.transform = 'rotateY(' + 180 * this.rotateY + 'deg)';
    },
    verticalPic(elename) {
      this.rotateX = this.rotateX + 1
      var box = document.getElementById(elename);
      box.style.transform = 'rotateX(' + 180 * this.rotateX + 'deg)';
    },
    hidePic(){
      document.getElementById('groundtruth_true').style.display = "none"
      if (this.classification_info.source.length === 0
          && this.annot_type_info.source.length === 0
          && this.fine_annot_type_info.source.length === 0) {
        document.getElementById('left_overview').style.display = "none"
      }
    },
    initClassificationEcharts(){
      let _this = this
      console.log(_this.classification_info.types)
      let classification_div = document.getElementById("class_true");
      const chart_classification = echarts.init(classification_div);
      // const chart_major = echarts.init(document.getElementById('celltype_major'));
      // const chart_minor = echarts.init(document.getElementById('celltype_minor'));
      // const chart_subset = echarts.init(document.getElementById('celltype_subset'));
      let option;
      option = {
        title:{
          text: 'spatial domain',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage : {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        dataset: {
          source: _this.classification_info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        // visualMap: _this.echart_info_overview.classification_info.tip,
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          // pieces: _this.classification_info.tip,
          // textStyle: {
          //   fontStyle: 'italic',
          //   width: '10px',
          //   overflow: 'truncate'
          // },
          categories: _this.classification_info.types,
          inRange: {
            color: ['#37A2DA','#e06343','#37a354','#b55dba','#b5bd48','#8378EA','#96BFFF','#E72178',
              '#354E6C','#EAAC31','#EAD2AE','#127678','#30B5A4','#B4D9D2','#354581','#FFE074',
              '#E03C79','#88C1B8','#FC6746','#F5B307','#008186'
            ]
          },
          // formatter: function (value) {
          //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          // },
          // inverse: true
          // categories: ['Stroma', 'Invasive cancer + stroma + lymphocytes','Invasive cancer + stroma','NA','Artefact'],
        },
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        // legend: {
        //   // orient: 'vertical',
        //   // left: 'left'
        //   type: 'scroll',
        //   orient: 'horizontal',
        //   x:'center',
        //   y:'bottom',
        //   data: _this.classification_info.types
        // },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        // series: _this.echart_info_overview.classification_info.series
        series: [{
          show: false,
          name: _this.classification_info.types[0],
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: _this.classification_info.spotSize,
          // symbolSize: 10,
          itemStyle: {
            // color: '#ff0000'
            normal:{
              color: function (p){
                let index = _this.classification_info.types.indexOf(p.value[0])
                // if(p.data[0] === 'NA'){console.log(p.data)}
                return _this.COLOR_ALL[index]
              }
            }
          }
        }]
      }
      option && chart_classification.setOption(option);
    },
    initAnnoEcharts(){
      let _this = this
      let _div = document.getElementById('anno_true');
      const myChart = echarts.init(_div);
      // const chart_major = echarts.init(document.getElementById('celltype_major'));
      // const chart_minor = echarts.init(document.getElementById('celltype_minor'));
      // const chart_subset = echarts.init(document.getElementById('celltype_subset'));
      let option;
      option = {
        title:{
          text: 'annotation type',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage : {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        dataset: {
          source: _this.annot_type_info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        // visualMap: _this.echart_info_overview.classification_info.tip,
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          // pieces: _this.annot_type_info.tip,
          categories: _this.annot_type_info.types,
          inRange: {
            color: ['#37A2DA','#e06343','#37a354','#b55dba','#b5bd48','#8378EA','#96BFFF','#E72178',
              '#354E6C','#EAAC31','#EAD2AE','#127678','#30B5A4','#B4D9D2','#354581','#FFE074',
              '#E03C79','#88C1B8','#FC6746','#F5B307','#008186'
            ]
          },
          // formatter: function (value) {
          //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          // },
          // categories: ['Stroma', 'Invasive cancer + stroma + lymphocytes','Invasive cancer + stroma','NA','Artefact'],
        },
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        // series: _this.echart_info_overview.classification_info.series
        series: [{
          show: false,
          name: 'Detail',
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: _this.annot_type_info.spotSize,
          // symbolSize: 10,
          itemStyle: {
            // color: '#ff0000'
            normal:{
              color: function (p){
                let index = _this.annot_type_info.types.indexOf(p.value[0])
                // if(p.data[0] === 'NA'){console.log(p.data)}
                return _this.COLOR_ALL[index]
              }
            }
          }
        }]
      }
      option && myChart.setOption(option);
    },
    initFineAnnoEcharts(){
      let _this = this
      let _div = document.getElementById('fine_anno_true');
      const myChart = echarts.init(_div);
      // const chart_major = echarts.init(document.getElementById('celltype_major'));
      // const chart_minor = echarts.init(document.getElementById('celltype_minor'));
      // const chart_subset = echarts.init(document.getElementById('celltype_subset'));
      let option;
      option = {
        title:{
          text: 'fine annotation type',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage : {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        dataset: {
          source: _this.fine_annot_type_info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        // visualMap: _this.echart_info_overview.classification_info.tip,
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          // pieces: _this.fine_annot_type_info.tip,
          categories: _this.fine_annot_type_info.types,
          inRange: {
            color: ['#37A2DA','#e06343','#37a354','#b55dba','#b5bd48','#8378EA','#96BFFF','#E72178',
              '#354E6C','#EAAC31','#EAD2AE','#127678','#30B5A4','#B4D9D2','#354581','#FFE074',
              '#E03C79','#88C1B8','#FC6746','#F5B307','#008186'
            ]
          },
          // formatter: function (value) {
          //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          // },
          // categories: ['Stroma', 'Invasive cancer + stroma + lymphocytes','Invasive cancer + stroma','NA','Artefact'],
        },
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        // series: _this.echart_info_overview.classification_info.series
        series: [{
          show: false,
          name: 'Detail',
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: _this.fine_annot_type_info.spotSize,
          // symbolSize: 10,
          itemStyle: {
            // color: '#ff0000'
            normal:{
              color: function (p){
                let index = _this.fine_annot_type_info.types.indexOf(p.value[0])
                // if(p.data[0] === 'NA'){console.log(p.data)}
                return _this.COLOR_ALL[index]
              }
            }
          }
        }]
      }
      option && myChart.setOption(option);
    },
  }
}
</script>

<style scoped>
.flex_row{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /*flex-direction: column;*/
  justify-content: space-evenly;
  align-items: center;

}
</style>
